import { Actor, Keys, Scene, SpriteSheet, TileMap, Vector } from "excalibur";

import { Player } from "../player";
import { inventoryState } from "../state/stateManager";
import { createGainedItem, sendAlert } from "../utils";
import { goToScene } from "../main";
import { Resources } from "../Resources";
import frame from "./../../res/honeyFrame.png";
export default class Extraction extends Scene {
  constructor() {
    super();
    this.player = new Player(100, 160, () => {
      this.setPlayerAnim(false);
    });

    this.player.scale = new Vector(4, 4);
    this.playerAnim = false;
    this.player.z = 3;
    this.player.cutScene = true;
    this.direction = true;
    this.progress = 0;
    this.ui = document.getElementById("extraction");
    this.progressBar = document.getElementById("progress");
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }
  onActivate(data) {
    this.inventory = inventoryState.getInventory();
    console.log("data from activation ", this.inventory);
    this.add(this.player);
    //get control of ui element for instructions
    this.ui.style.display = "flex";
    this.ui.innerHTML = `<h1><img src="${frame}"/> ${parseFloat(
      this.inventory.harvestedHoney
    ).toFixed(2)}</h1><h1>Buckets: ${parseFloat(this.inventory.buckets).toFixed(
      2
    )}</h1>
    <p class="firstP">Alternate Up/Down Keys To Spin Frames</p><p>X> BACK</p>
    <div id="progressBar"><div id="progress"/></div>
    
    `;
  }
  changeHarvestedFrames(amount) {
    this.inventory.harvestedHoney = this.inventory.harvestedHoney - amount;
    if (this.inventory.harvestedHoney < 0) {
      this.inventory.harvestedHoney = 0;
    }
    this.inventory.buckets = this.inventory.buckets + 0.16;
    const gainedText = "Spun " + amount + " Frames!";
    Resources.Won.play();
    createGainedItem(gainedText);
  }
  setProgress(prog) {
    this.progress += prog;
    if (this.progress >= 100) {
      this.progress = 0;
      this.changeHarvestedFrames(3);
    }
    const width = `${this.progress * 3}px`;
    console.log("progress width is ", width);

    this.ui.innerHTML = `<h1><img src="${frame}"/> ${parseFloat(
      this.inventory.harvestedHoney
    ).toFixed(2)}</h1><h1>Buckets: ${parseFloat(this.inventory.buckets).toFixed(
      2
    )}</h1>
    <p class="firstP">Alternate Up/Down Keys To Spin Frames</p><p>X> BACK</p>
    <div id="progressBar"><div id="progress" style="width:${
      this.progress * 3
    }px"/></div>`;
    this.progressBar.setAttribute("style", `width:${width}`);
    console.log("progress is: ", this.progress);
  }
  onPostUpdate() {
    if (!this.playerAnim) {
      this.player.graphics.use("holdingExtractor");
    }

    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      if (this.direction && this.inventory.harvestedHoney > 0) {
        this.playerAnim = true;
        this.player.doAnim("turnExtractor");

        if (this.progress % 3 === 0) {
          Resources.WoodSound.play(0.5);
        }
        this.setProgress(2);
        this.direction = false;
      }
      if (this.inventory.harvestedHoney <= 0) {
        sendAlert("No Honey Frames To Spin");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      if (!this.direction && this.inventory.harvestedHoney > 0) {
        this.playerAnim = true;
        this.player.doAnim("turnExtractor");
        if (this.progress % 5 === 0) {
          Resources.Grunt.play(0.05);
        }
        this.setProgress(2);
        this.direction = true;
      }
      if (this.inventory.harvestedHoney <= 0) {
        sendAlert("No Honey Frames To Spin");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      this.ui.style.display = "none";
      goToScene("honeyHouse");
    }
  }
  onDeactivate() {}
}
